/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import Typography from '@material-ui/core/Typography';
import Media from 'react-media';
import withStyles from '@material-ui/core/styles/withStyles';
import { object, bool, string } from 'prop-types';

import PriceRange from '../../../GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/DesktopSimpleProduct/PriceRange';
import isDesktopMobileTablet from '../../../../../helpers/DesktopMobile/isDesktopMobileTablet';

const styles = () => ({
    productPrice: {
        fontWeight: 'bold',
    },
    body1: {
        lineHeight: '1.25',
    },
    titleRow: {
        marginTop: '1rem',
        wordBreak: 'break-word',
    },
    occasionsTitleRow: {
        marginTop: '0.5rem',
        wordBreak: 'break-word',
    },
    plantOccasionsTitle: {
        color: '#000',
        width: 'unset',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: '0.8px',
    },
});

const ProductTitle = ({
    product: item, classes, presentationFamily, isZodiacProduct, isPlantsForOccasions,
}) => {
    const productNameClasses = 'title bgsTitle';
    const priceClasses = 'price bgsTitle';

    return (
        <div className={isPlantsForOccasions ? classes.occasionsTitleRow : classes.titleRow}>
            <div>
                <span role="region" aria-label="product name" className={`${productNameClasses} ${isZodiacProduct ? 'zodiacProductTitle' : null} ${isPlantsForOccasions ? classes.plantOccasionsTitle : ''} productTitle`}>{item?.name}</span>
                { !isZodiacProduct && (
                    <span className={`${priceClasses} pricelist`} style={{ letterSpacing: '.5px' }}>
                        <Typography classes={{ body1: classes.body1 }} className={classes.productPrice}>
                            <Media query="(min-width: 769px)">
                                {() => <PriceRange presentationFamily={presentationFamily}  skuPriceRange={item?.skuPriceRange} isMobile={!isDesktopMobileTablet} />}
                            </Media>
                        </Typography>
                    </span>
                )}
            </div>
        </div>
    );
};

ProductTitle.propTypes = {
    product: object.isRequired,
    classes: object.isRequired,
    presentationFamily: string,
    isZodiacProduct: bool,
    isPlantsForOccasions: bool,
};

ProductTitle.defaultProps = {
    isZodiacProduct: false,
    isPlantsForOccasions: false,
    presentationFamily: '',
};

export default withStyles(styles)(ProductTitle);
